import * as React from 'react';
import createPlugin from 'bugsnag-react'
import BugsnagClient from './bugsnag-client';
import { BeforeSend } from 'bugsnag-js/types/common';

type ErrorBoundaryComp = React.SFC<{
    beforeSend?: BeforeSend,
    FallbackComponent: () => JSX.Element
}>;

const EmptyErrorBoundary: ErrorBoundaryComp = ((Comp: React.ComponentType) => <Comp />) as any;
const ErrorBoundaryCreator: () => ErrorBoundaryComp = () =>
    BugsnagClient.getInstance() &&
    BugsnagClient.getInstance().use(createPlugin(React)) ||
    EmptyErrorBoundary;

export default ErrorBoundaryCreator;


// WEBPACK FOOTER //
// ./packages/platform-utils/logging/bugsnag/ErrorBoundary.tsx